module.exports = __webpack_public_path__ + "img/C1.d7ade63f.webp";